import React from 'react';
import {hoverUnderlineClass, sessid} from '../../common/baseData';

function LangSwitch(props) {
  const [state, setState] = React.useState(window.langsData || {});
  const selectedClass = 'font-medium text-grey-90 cursor-default';
  const defaultClass = 'text-grey-80';

  return (
    <ul className="flex gap-3">
      {
        state.hasOwnProperty('langList') && Array.isArray(state.langList) ?
          state.langList.map((lang, index) => (
            <li key={index}>
              <a
                  href={lang.link}
                  onClick={(e) => {
                    if (state.searchQuery && state.searchQuery.trim() !== '') {
                      e.preventDefault();

                      // Создаем форму для отправки POST-запроса
                      const form = document.createElement('form');
                      form.method = 'POST';
                      form.action = lang.link;
                      form.style.display = 'none';

                      // Добавляем параметр q со значением из state.searchQuery
                      const input = document.createElement('input');
                      input.type = 'hidden';
                      input.name = 'q';
                      input.value = state.searchQuery;

                      // Добавляем параметр сессии
                      const inputSessid = document.createElement('input');
                      inputSessid.type = 'hidden';
                      inputSessid.name = 'sessid';
                      inputSessid.value = sessid;

                      form.appendChild(input);
                      form.appendChild(inputSessid);
                      document.body.appendChild(form);
                      form.submit();

                      // Удаляем форму после отправки
                      document.body.removeChild(form);
                    }
                  }}
                  className={`bg-transparent border-0 p-0 text-[14px] cursor-pointer leading-[21px] ${lang.selected ? selectedClass : defaultClass} ${hoverUnderlineClass}`}
              >
                {lang.title}
              </a>
            </li>
          )) :
          <></>
      }
    </ul>
  );
}

export default LangSwitch;